import { JSX } from 'react'

export const CompareGrid = ({
  compareLogos,
  compareItems,
  id,
  oneColumn,
}: {
  compareLogos?: JSX.Element[]
  compareItems: JSX.Element[][]
  id: string
  oneColumn?: boolean
}) => {
  return (
    <div className="compare-grid">
      <div className="compare-grid-row compare-grid-logos">
        {compareLogos &&
          compareLogos.map((logo, index) => {
            return (
              <div className="compare-grid-logo" key={`logo-${index}-${id}`}>
                {logo}
              </div>
            )
          })}
      </div>
      {compareItems.map((items, index) => {
        return (
          <div
            className={`${oneColumn ? 'compare-grid-row-one-col' : 'compare-grid-row'}`}
            key={`row-${index}-${id}`}
          >
            {items.map((item, subIndex) => {
              return <div key={`row-${index}-${subIndex}-${id}`}>{item}</div>
            })}
          </div>
        )
      })}
    </div>
  )
}
